var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommonIconPhoneNumberSmall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.83333C2 3.47971 2.14048 3.14057 2.39052 2.89052C2.64057 2.64048 2.97971 2.5 3.33333 2.5H5.52C5.65986 2.50011 5.79615 2.5442 5.90957 2.62603C6.02299 2.70787 6.1078 2.8233 6.152 2.956L7.15067 5.95133C7.20127 6.10356 7.19528 6.26893 7.13381 6.4171C7.07234 6.56527 6.9595 6.6863 6.816 6.758L5.31133 7.51133C6.04888 9.14369 7.35631 10.4511 8.98867 11.1887L9.742 9.684C9.8137 9.5405 9.93473 9.42766 10.0829 9.36619C10.2311 9.30472 10.3964 9.29873 10.5487 9.34933L13.544 10.348C13.6768 10.3922 13.7923 10.4771 13.8742 10.5907C13.956 10.7043 14 10.8407 14 10.9807V13.1667C14 13.5203 13.8595 13.8594 13.6095 14.1095C13.3594 14.3595 13.0203 14.5 12.6667 14.5H12C6.47733 14.5 2 10.0227 2 4.5V3.83333Z",
    stroke: "#6B7280",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonIconPhoneNumberSmall);
export default __webpack_public_path__ + "static/media/common_icon_phone_number_small.c7085d3d373717faa4b7ceb40de0fb61.svg";
export { ForwardRef as ReactComponent };